import React from "react";
import {connect} from "react-redux";
import {utils} from "@mc/mc-legacy";
import GroupMenu from "../components/GroupMenu";
import CustomPageLayout from "./CustomPageLayout";
import ItemList from "../components/ItemList";
import * as actions from "../actions/historieUkolDokumentyActions";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import {Button, Col, Row} from "reactstrap";
import SignRequestTitle from "../components/SignRequestTitle";
import ShowButton from "../components/ShowButton";
import RequestDocumentStatusIcon from "../components/RequestDocumentStatusIcon";
import MessageEmptyList from "../components/MessageEmptyList";
import LabeledValue from "../components/LabeledValue";
import * as appUtils from "../utils/appUtils";
import EnumState from "../api/gen/qsign/types/EnumState";
import moment from "moment";
import PodepisovaniPdfViewer from "../components/PodepisovaniPdfViewer";
import SignRequestWithCountsVO from "../api/gen/qsign/types/SignRequestWithCountsVO";
import PrilohyButton from "../components/PrilohyButton";

/**
 * Historie úkoly dokumenty page.
 */

class UkolyHistoriePage extends React.Component {
  componentDidMount() {
    this.fetchData(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps, false);
  }

  fetchData = (props, forceFetch) => {
    const { dispatch } = props;
    dispatch(actions.fetchIfNeeded(forceFetch));
  };
  handleZobrazit = (signRequest, onClose = null, viewMode) => {
    this.props.dispatch(pdfViewerActions.showDocument(signRequest, onClose, viewMode, screen.width));
  };
  renderSignedOrRejected = (item) => {
    if (item.state === EnumState.REJECTED) {
      return <LabeledValue label="Odmítnuto" value={item.rejected ? this.formatDate(item.rejected) : "-"} />;
    } else if (item.state === EnumState.SIGNED) {
      return <LabeledValue label="Podepsáno" value={item.signed ? this.formatDate(item.signed) : "-"} />;
    }

    return null;
  };

  formatDate = (date) => {
    return moment(date).format("DD.M.YYYY");
  };
    renderItem = (item: SignRequestWithCountsVO, icon) => {
        const { error } = item;
        let podepisujici = item.pracovnikSignList.map((pracovnik) => appUtils.getPracovnikLabel(pracovnik));
        podepisujici = podepisujici.join(", ");
        return (
            <Row noGutters className={"document-row ukoly-historie"}>
                <Col
                    xl={9}
                    lg={9}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{margin: "auto"}}
                >
                    <Row className="d-md-none">
                        <Col className="ml-3">
                            <SignRequestTitle
                                onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.MOBILE)}
                                signRequest={item}
                            />
                        </Col>
                    </Row>
                    {/*<Col lg={5} md={12} className={"center-y"}>*/}
                    {/*    <SignRequestDocumentData requestDocument={item}/>*/}
                    {/*</Col>*/}
                    <Row className={"mt-2 mb-2 pl-4 pr-4"}>
                        <Col lg={4} md={4} className="d-none d-lg-block">
                            <SignRequestTitle
                                disabled={item.deleted}
                                onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}
                                signRequest={item}
                                icon
                                customRender={(item) => {
                                    if (item.attachmentCount > 0) {
                                        return <PrilohyButton attachmentCount={item.attachmentCount} itemID={item.requestId} />;
                                    }
                                }}
                            />
                        </Col>
                        <Col lg={2} md={2} sm={6} xs={4}>
                            <LabeledValue label="Předloženo" value={this.formatDate(item.created)} />
                        </Col>
                        <Col lg={2} md={2} sm={6} xs={8}>
                            <LabeledValue label="Předkladatel" value={appUtils.getPracovnikLabel(item.pracovnikRequest)} />
                        </Col>
                        <Col lg={2} md={2} sm={6} xs={4}>
                            {this.renderSignedOrRejected(item)}
                        </Col>
                        <Col lg={2} md={2} sm={6} xs={8}>
                            <LabeledValue label="Podepisující" value={podepisujici} />
                        </Col>
                    </Row>
                </Col>
                {!error && (
                    <Col lg={1} md={6} xs={6} sm={6} className=" justify-content-center d-none d-md-flex align-items-center">
                        <RequestDocumentStatusIcon requestDocument={item} size="3x" />
                    </Col>
                )}
                {!error && (
                    <Col
                        xs={6}
                        sm={6}
                        className="d-md-none d-flex align-items-center justify-content-center"
                        style={{
                            borderTop: "1px solid #dfe2f1",
                        }}
                    >
                        <RequestDocumentStatusIcon requestDocument={item} />
                    </Col>
                )}
                <Col md={6} lg={2} className={"action-button-wrapper d-none d-md-flex pt-3 pb-3"}>
                    <ShowButton
                        disabled={item.deleted}
                        onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}
                    />
                </Col>
                <Col xs={6} sm={6} className="d-md-none mr-0">
                    <Button
                        block
                        className={"btn-lg"}
                        color={"primary"}
                        onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.MOBILE)}
                    >
                        Zobrazit
                    </Button>
                </Col>
            </Row>
        );
    };

  render() {
    const { itemList } = this.props;
    const listProps = {
      md: 12,
      itemList,
      loadMore: actions.loadMore,
      invalidatePozadavky: actions.invalidatePozadavky,
      renderItem: this.renderItem,
      renderActions: () => {},
      emptyList: (
        <MessageEmptyList>
          <div className="message">Žádné dokumenty v historii</div>
        </MessageEmptyList>
      ),
    };
    return (
      <CustomPageLayout
        header
        vlastniPodepsaniHeader={true}
        headerButton={false}
        title="Historie zpracovaných dokumentů"
        mobilHeader="Historie"
        menu={<GroupMenu />}
      >
        <ItemList {...listProps} />
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    itemList: utils.storeFromArea(state, actions.HISTORIE_UKOL_DOKUMENTY_LIST),
  };
}

export default connect(mapStateToProps)(UkolyHistoriePage);
